<template>
    <div>
        <breadcrumb :items="breadcrumbs"></breadcrumb>
        <v-container>
            <v-card flat class="pr-10">
                <v-card-text>
                    <div class="d-flex flex-no-wrap justify-space-between">
                        <div>
                            <v-card-title class="text-h5 font-weight-bold primary--text mb-2">
                                Genetics and Breeding User Guide
                            </v-card-title>
            
                            <v-card-subtitle class="black--text">The admin must follow the first two flows below to calculate the EPD (Expected Progeny Differences) of animals in the system. The EPDs may then be used to value the animals and improve the breed (i.e. the traits) of their future generations. 
                            </v-card-subtitle>
                            <v-card-subtitle class="black--text">The required animal data is provided by the breeders/farmers/users as described in the last flow below.
                            </v-card-subtitle>
                        </div>
    
                            <v-avatar
                                class="ma-3"
                                size="280"
                                rounded="0"
                            >
                                <v-img src="/img/cow.png"></v-img>
                            </v-avatar>
                </div>
                </v-card-text>
            </v-card>

            <div class="py-4 px-2 title font-weight-bold primary--text">Reset Mode Flow - for the Admin User</div>

            <v-card flat class=" pr-10">
                <v-card-text>
                    <div class="d-flex flex-no-wrap justify-space-between">
                        <div>
                            <v-card-title class="subtitle-1 font-weight-bold black--text">
                                1 - Selection of Animals for the EPD Calculations
                            </v-card-title>
            
                            <v-card-subtitle class="body black--text mt-2">The Admin should select the animals in the system to be included in EPD Calculations
                            </v-card-subtitle>
            
                            <v-card-actions>
                                <router-link class="ml-3" color="#0057BD" :to="{name: 'Genetics'}">Go to this page</router-link>
                            </v-card-actions>
                        </div>
    
                        <v-avatar
                            @click="openDialoge(0)"
                            class="ma-3"
                            size="200"
                            rounded="0"
                        >
                            <v-img src="/img/screens/epd-cal.png"></v-img>
                        </v-avatar>
                    </div>
                    <v-divider></v-divider>
                    <div class="d-flex flex-no-wrap justify-space-between">
                        <div>
                            <v-card-title class="subtitle-1 font-weight-bold black--text">
                                2 - EPD Model Settings
                            </v-card-title>
            
                            <v-card-subtitle class="body black--text  mt-2">The Admin Should read the model’s description and input the model’s settings
                            </v-card-subtitle>
            
                            <v-card-actions>
                                <router-link class="ml-3" color="#0057BD" :to="{name: 'modelSettings'}">Go to this page</router-link>
                            </v-card-actions>
                        </div>
    
                        <v-avatar
                            @click="openDialoge(1)"
                            class="ma-3"
                            size="200"
                            rounded="0"
                        >
                            <v-img src="/img/screens/model-settings.png"></v-img>
                        </v-avatar>
                    </div>
                    <v-divider></v-divider>
                    <div class="d-flex flex-no-wrap justify-space-between">
                        <div>
                            <v-card-title class="subtitle-1 font-weight-bold black--text">
                                3 - Required EPD Fields Settings
                            </v-card-title>
            
                            <v-card-subtitle class="body black--text mt-2">For each trait of interest (e.g. Birth Weight, Weaning Weight, etc.), The Admin should check the fields that are required to define a contemporary group (CG)
                            </v-card-subtitle>
            
                            <v-card-actions>
                                <router-link class="ml-3" color="#0057BD" :to="{name: 'requiredFieldsSetting'}">Go to this page</router-link>
                            </v-card-actions>
                        </div>
    
                        <v-avatar
                            @click="openDialoge(2)"
                            class="ma-3"
                            size="200"
                            rounded="0"
                        >
                            <v-img src="/img/screens/required-fields.png"></v-img>
                        </v-avatar>
                    </div>
                    <v-divider></v-divider>
                    <div class="d-flex flex-no-wrap justify-space-between">
                        <div>
                            <v-card-title class="subtitle-1 font-weight-bold black--text">
                                4 - Contemporary Groups (CGs) Settings
                            </v-card-title>
            
                            <v-card-subtitle class="body black--text mt-2">In the Contemporary Groups page, the Admin should press the <b>[ADD NEW GROUP]</b> button to get to the Add New Contemporary Group page. Then, for each trait of interest and for each different CG, the Admin should set the ranges for the fields required to define a particular CG (checked in 3 above) in the boxes highlighted in yellow. Each CG should have a different range of those fields/parameters.
                            </v-card-subtitle>
            
                            <v-card-actions>
                                <router-link class="ml-3" color="#0057BD" :to="{name: 'contemporaryGroups'}">Go to this page</router-link>
                            </v-card-actions>
                        </div>
    
                        <v-avatar
                            @click="openDialoge(3)"
                            class="ma-3"
                            size="200"
                            rounded="0"
                        >
                            <v-img src="/img/screens/ContemporaryGroups.png"></v-img>
                        </v-avatar>
                    </div>
                    <div class="d-flex flex-no-wrap justify-space-between">
                        <div>
                            <v-card-title class="subtitle-1 font-weight-bold black--text">&nbsp;</v-card-title>
            
                            <v-card-subtitle class="body black--text">&nbsp;</v-card-subtitle>
            
                            <v-card-actions></v-card-actions>
                        </div>
    
                        <v-avatar
                            @click="openDialoge(4)"
                            class="ma-3"
                            size="200"
                            rounded="0"
                        >
                            <v-img src="/img/screens/ContemporaryGroups2.png"></v-img>
                        </v-avatar>
                    </div>
                    <v-divider></v-divider>
                    <div class="d-flex flex-no-wrap justify-space-between">
                        <div>
                            <v-card-title class="subtitle-1 font-weight-bold black--text">
                                5 - Assigning Animals to Contemporary Groups (CGs)
                            </v-card-title>
            
                            <v-card-subtitle class="body black--text mt-2">While in Reset Mode, Admin should assign the animals selected in 1 above to the CGs defined in 4 above by pressing the <b>[ASSIGN ANIMALS TO CGs]</b> button.
                            </v-card-subtitle>
            
                            <v-card-actions>
                                <router-link class="ml-3" color="#0057BD" :to="{name: 'ManageAnimalsGroup'}">Go to this page</router-link>
                            </v-card-actions>
                        </div>
    
                        <v-avatar
                            @click="openDialoge(5)"
                            class="ma-3"
                            size="200"
                            rounded="0"
                        >
                            <v-img cover src="/img/screens/5 - ManageAnimalsGroupings.png"></v-img>
                        </v-avatar>
                    </div>
                    <v-divider></v-divider>
                    <div >
                        <v-card-title class="subtitle-1 font-weight-bold black--text">
                            6 - Completing Reset Mode in order to Switch to Maintenance Mode
                        </v-card-title>
                        <div class="d-flex flex-no-wrap justify-space-between">
                            <div class="pl-6">
                                <v-card-subtitle class="body black--text"><v-btn depressed color="#FFB443" class="mr-2 text-lowercase" style="width:30px; height: 30px; min-width: 0; min-height: 0;">a</v-btn>If upon assigning the animals in the system to CGs (in 5 above) the admin is satisfied with how the animals were distributed among the CGs (defined by the admin in 4 above), then the admin should switch to Maintenance Mode by pressing the <b>[RESET FINALIZED - CHANGE TO MAINTENANCE MODE]</b> button.
                                </v-card-subtitle>
                                <v-card-subtitle class="body black--text"><v-btn depressed color="#FFB443" class="mr-2 text-lowercase" style="width:30px; height: 30px; min-width: 0; min-height: 0;">b</v-btn>If upon assigning the selected animals in the system to CGs (in 5 above) the admin is NOT satisfied with how the animals were distributed among the CGs (defined by the admin in 4 above), then the admin may reinitiate Reset Mode, by pressing the <b>[REINITIATE RESET FlOW]</b> button, and adjust the animals selection and CGs by repeating steps 1 - 6 above (various times, if necessary) until 6a above is reached, at which point Reset Mode is completed and the system is switched to Maintenance Mode.
                                </v-card-subtitle>
                            </div>
        
                            <v-avatar
                                 @click="openDialoge(6)"
                                class="ma-3"
                                size="200"
                                rounded="0"
                            >
                                <v-img src="/img/screens/6a.png"></v-img>
                            </v-avatar>
                        </div>
                        <div class="d-flex flex-no-wrap justify-space-between">
                            <div>
                                <v-card-actions>
                                    <router-link class="ml-8" color="#0057BD" :to="{name: 'ManageAnimalsGroup'}">Go to this page</router-link>
                                </v-card-actions>
                            </div>
        
                            <v-avatar
                                @click="openDialoge(7)"
                                class="ma-3"
                                size="200"
                                rounded="0"
                            >
                                <v-img src="/img/screens/6b.png"></v-img>
                            </v-avatar>
                        </div>
                    </div>
                </v-card-text>
            </v-card>

            <div class="py-4 px-2 title font-weight-bold primary--text">Maintenance Mode Flow - For Admin User</div>

            <v-card flat class=" pr-10">
                <v-card-text>
                    <div class="d-flex flex-no-wrap justify-space-between">
                        <div>
                            <v-card-title class="subtitle-1 font-weight-bold black--text">
                                7 - EPD Calculations
                            </v-card-title>
            
                            <v-card-subtitle class="body black--text mt-2">At the time Reset Mode is completed and Maintenance Mode is started, the EPDs of all the animals that ended up in CGs is calculated and those EPD values remain the same during the entire Maintenance Mode. The Admin may see the EPD values of animals by using the “Genetic / Animals Search Tool” screen.
                            </v-card-subtitle>
            
                            <v-card-actions>
                                <router-link class="ml-3" color="#0057BD" :to="{name: 'GeneticSearch'}">Go to this page</router-link>
                            </v-card-actions>
                        </div>
    
                        <v-avatar
                             @click="openDialoge(8)"
                            class="ma-3"
                            size="200"
                            rounded="0"
                        >
                            <v-img src="/img/screens/EPDCalculations.png"></v-img>
                        </v-avatar>
                        
                    </div>
                    <div class="d-flex flex-no-wrap justify-space-between">
                        <div>
                            <v-card-title class="subtitle-1 font-weight-bold black--text">&nbsp;</v-card-title>
            
                            <v-card-subtitle class="body black--text">&nbsp;</v-card-subtitle>
            
                            <v-card-actions></v-card-actions>
                        </div>
    
                        <v-avatar
                            @click="openDialoge(9)"
                            class="ma-3"
                            size="200"
                            rounded="0"
                        >
                            <v-img src="/img/screens/EPDCalculations-b.png"></v-img>
                        </v-avatar>
                    </div>
                    <v-divider></v-divider>
                    <div class="d-flex flex-no-wrap justify-space-between">
                        <div>
                            <v-card-title class="subtitle-1 font-weight-bold black--text">
                                8 - Maintenance Mode
                            </v-card-title>
            
                            <v-card-subtitle class="body black--text mt-2">The Admin may stay in maintenance mode for any amount of time (days, weeks or months). The EPDs of new animals added to the system during Maintenance Mode are calculated by another method, if the new animal added has the necessary parameters values for such calculation.
                            </v-card-subtitle>
            
                            <v-card-actions>
                                <router-link class="ml-3" color="#0057BD" :to="{name: 'ManageAnimalsGroup'}">Go to this page</router-link>
                            </v-card-actions>
                        </div>
    
                        <v-avatar
                             @click="openDialoge(10)"
                            class="ma-3"
                            size="200"
                            rounded="0"
                        >
                            <v-img src="/img/screens/maintainance-mode.png"></v-img>
                        </v-avatar>
                    </div>
                    <v-divider></v-divider>
                    <div class="d-flex flex-no-wrap justify-space-between">
                        <div>
                            <v-card-title class="subtitle-1 font-weight-bold black--text">
                                9 - Switching back to Reset Mode to update the EPDs
                            </v-card-title>
            
                            <v-card-subtitle class="body black--text mt-2">After several weeks or months in Maintenance mode, the Admin should switch back to Reset Mode in order to more accurately calculate the EPDs of all animals, specially those newly added during this last Maintenance mode. Therefore, the Admin should restart the Reset Mode flow (described in 1-5 above) and subsequently the Maintenance Mode Flow (described in 7-9 above), and this cycle can be repeated consecutively for many years.
                            </v-card-subtitle>
            
                            <v-card-actions>
                                <router-link class="ml-3" color="#0057BD" :to="{name: 'ManageAnimalsGroup'}">Go to this page</router-link>
                            </v-card-actions>
                        </div>
    
                        <v-avatar
                            @click="openDialoge(11)"
                            class="ma-3"
                            size="200"
                            rounded="0"
                        >
                            <v-img src="/img/screens/reset-mode.png"></v-img>
                        </v-avatar>
                    </div>
                </v-card-text>
            </v-card>
            <div class="py-4 px-2 title font-weight-bold primary--text">Required Input Data Flow - For the Breeders/Farmers/Users</div>
            <v-card flat class=" pr-10">
                <v-card-text>
                    <div class="d-flex flex-no-wrap justify-space-between">
                        <div>
                            <v-card-title class="subtitle-1 font-weight-bold black--text">
                                Required Input Data
                            </v-card-title>
            
                            <v-card-subtitle class="body black--text mt-2">An animal’s EPDs are calculated only if the system has the values of the animal’s parameters that are necessary to calculate the animal’s EPDs (the necessary parameters are set in 2 above). Accordingly, breeders/farmers/users must plan to regularly and accurately record and provide the proper data over the lives of many generations of their animals.
                            </v-card-subtitle>
            
                            <v-card-actions>
                                <router-link class="ml-3" color="#0057BD" :to="{name: 'GeneticsDataSubmission'}">Go to this page</router-link>
                            </v-card-actions>
                        </div>
    
                        <v-avatar
                            @click="openDialoge(12)"
                            class="ma-3"
                            size="200"
                            rounded="0"
                        >
                            <v-img src="/img/screens/required-input.png"></v-img>
                        </v-avatar>
                    </div>
                </v-card-text>
            </v-card>
        </v-container>
        <image-viewer
        :dialog="showViewImage"
        :imgData="imageData"
        >
        </image-viewer>
    </div>
</template>

<script>
import ImageViewerVue from './ImageViewer.vue'
export default {
    data() {
        return {
            breadcrumbs: [
                {
                    text: this.$t('dashboard'),
                    disabled: false,
                    to: "/",
                },
                {
                    text: this.$t('EPD User Guide'),
                    disabled: true,
                    to: { name: "" },
                },
            ],
            allItems:[
                {id:0, group: 1,text:"Selection of Animals for the EPD Calculations",src:"/img/screens/epd-cal.png"},
                {id:1, group:2, text:"EPD Model Settings",src:"/img/screens/model-settings.png"},
                {id:2, group:3, text:"Required EPD Fields Settings",src:"/img/screens/required-fields.png"},
                {id:3, group:4, text:"Contemporary Groups (CGs) Settings",src:"/img/screens/ContemporaryGroups.png"},
                {id:4, group:4, text:"Contemporary Groups (CGs) Settings",src:"/img/screens/ContemporaryGroups2.png"},
                {id:5, group:5, text:"Assigning Animals to Contemporary Groups (CGs)",src:"/img/screens/5 - ManageAnimalsGroupings.png"},
                {id:6, group:6, text:"Completing Reset Mode in order to Switch to Maintenance Mode",src:"/img/screens/6a.png"},
                {id:7, group:6, text:"Completing Reset Mode in order to Switch to Maintenance Mode",src:"/img/screens/6b.png"},
                {id:8, group:7, text:"EPD Calculations",src:"/img/screens/EPDCalculations.png"},
                {id:9, group:7, text:"EPD Calculations",src:"/img/screens/EPDCalculations-b.png"},
                {id:10, group:8, text:"Maintenance Mode",src:"/img/screens/maintainance-mode.png"},
                {id:11, group:9, text:"Switching back to Reset Mode to update the EPDs",src:"/img/screens/reset-mode.png"},
                {id:12, group:10, text:"Required Input Data",src:"/img/screens/required-input.png"},
            ],

            showViewImage:false,
            imageData:{
                id:null,
                group: null,
                text:"",
                img:""
            }
        }
    },
    methods:{
        openDialoge(value){
            this.imageData={
                id:this.allItems[value].id,
                group: this.allItems[value].group,
                text:this.allItems[value].text,src:this.allItems[value].src
            };
            console.log({ image: this.imageData });
            this.showViewImage=true;
        }
    },
    components: {
    "image-viewer": ImageViewerVue
    }
}

</script>